import styled from 'styled-components';

export const QuickCopyTextStyled = styled.div`
  margin-top: 0.5rem;
  display: flex;
  width: 100%;
  background-color: rgb(243, 243, 243);
  border-radius: 1rem;
  :hover {
    background-color: rgb(240, 240, 240);
  }
  cursor: pointer;
  .content {
    width: 100%;
    padding: 10px 10px 10px 20px;
  }
  .icon {
    display: flex;
    align-items: center;
    margin-right: 1rem;
  }
`;
